'use client';

const ErrorBoundary = () => {
  return <></>;
};

export default ErrorBoundary;
